import { render, staticRenderFns } from "./budgetPerformancePermission.vue?vue&type=template&id=67702db4&scoped=true"
import script from "./budgetPerformancePermission.vue?vue&type=script&lang=js"
export * from "./budgetPerformancePermission.vue?vue&type=script&lang=js"
import style0 from "./budgetPerformancePermission.vue?vue&type=style&index=0&id=67702db4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67702db4",
  null
  
)

export default component.exports